import React, { useEffect } from "react";
import "../style/components/modal.css";

export function KalendariumModal({ event, title, text, onClose }) {
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [onClose]);

  if (!event) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) onClose();
  };

  return (
    <div
      className="modal-overlay"
      onClick={handleBackdropClick}
      tabIndex={0}
      role="dialog"
      aria-modal="true"
      aria-labelledby="kalendarium-modal-title"
    >
      <div className="modal-content kalendarium-modal">
        <div className="modal-header">
          <h2 id="kalendarium-modal-title">{title || event.date_str}</h2>
          <button className="close-button" onClick={onClose} aria-label="Zamknij modal">
            <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true">
              <path d="M0 0h24v24H0V0z" fill="none" />
              <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z" />
            </svg>
          </button>
        </div>

        <div className="modal-body">
          {event.cover_url && (
            <div className="show-image">
              <img src={event.cover_url} alt={event.date_str} />
            </div>
          )}

          <div className="show-description" style={{ flex: 1 }}>
            <p>{text || event.text}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
